/* eslint-disable */

import { grey } from '@material-ui/core/colors';
import Colors from '../../Support/Theme/Colors/Colors';

/**
 * Create styles for `<EditOrder />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<EditOrder />` styles
 */
const modalStyles = ({ theme }) => ({
  editOrder: {
    padding: theme.spacing(1) * 3,
  },
  row: {
    padding: `0 ${theme.spacing(1) * 3}px`,
    textTransform: 'none',
  },
  paperClassesInfo: {
    maxHeight: 500,
  },
  infoList: {
    margin: 0,
    padding: 0,
    listStyle: `none`,
    '&>li': {
      fontWeight: 500,
      fontSize: theme.typography.body2.fontSize,
      paddingTop: theme.spacing(1) * 0.5,
      paddingBottom: theme.spacing(1) * 0.5,
    },
  },
  heading: {
    color: Colors.boralgreen[500],
  },
  testingRequired: {
    opacity: 0.5,
    borderBottom: `1px dotted ${theme.palette.grey[`500`]}`,
  },
  phoneInputItem: {
    marginTop: -theme.spacing(1) * 2,
  },
  separator: {
    border: 0,
    height: 1,
    backgroundColor: grey[300],
    width: `100%`,
  },
  reportOpenTCs: {
    marginTop: theme.spacing(1) * 8,
  },
});

export default modalStyles;
